import { render } from "./PresentationSlideFive.vue?vue&type=template&id=2428b415&scoped=true"
const script = {}

import "./PresentationSlideFive.vue?vue&type=style&index=0&id=2428b415&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2428b415"]])

export default __exports__